import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useSnackbar } from 'notistack';
import { Box, Divider } from '@material-ui/core';
import Routes from 'routes';
import { useAppContext } from 'contexts/AppContext';
import { wait } from 'globals/utils';
import defaultLocales from 'globals/locales/default';
import FsPendingButton from 'ui-elements/buttons/FsPendingButton';
import FsButton from 'ui-elements/buttons/FsButton';
import { BillingInfoFormProps } from 'ui-elements/forms/FsBillingInfoForm/FsBillingInfoForm';
import { PaymentMethodFormProps } from 'ui-elements/forms/FsPaymentMethodForm/FsPaymentMethodForm';
import BillingCycle from './BillingCycle';
import BillingInfo from './BillingInfo';
import PaymentMethod from './PaymentMethod';

const PayAsYouGrow: React.FC = () => {
  const history = useHistory();
  const { setIsUpgraded } = useAppContext();
  const { enqueueSnackbar } = useSnackbar();
  const [
    isPaymentMethodFormValid,
    setIsPaymentMethodFormValid,
  ] = useState<boolean>(false);
  const [isBillingInfoFormValid, setIsBillingInfoFormValid] = useState<boolean>(
    false
  );
  const [pending, setPending] = useState<boolean>(false);
  const [formData, setFormData] = useState<Partial<string>>('{}');

  const successRedirect = (): void => {
    history.push({ pathname: Routes.BILLINGS });
  };

  const cancelRedirect = (): void => {
    history.push({ pathname: Routes.ROOT });
  };

  const handleSubscribe = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setPending(true);
    // eslint-disable-next-line no-console
    console.log('Subscribe', JSON.parse(formData));
    await wait(1000);
    setPending(false);
    enqueueSnackbar(defaultLocales.subscribeNotificationSuccess, {
      variant: 'success',
    });
    setIsUpgraded(true);
    successRedirect();
  };

  const updateFormData = (
    data?: Partial<PaymentMethodFormProps | BillingInfoFormProps>
  ) => {
    setFormData((currentState) =>
      JSON.stringify(
        {
          ...JSON.parse(currentState),
          ...data,
        },
        null,
        2
      )
    );
  };

  return (
    <Box maxWidth={622}>
      <Box marginBottom={8}>
        <BillingCycle />
      </Box>
      {/* <pre>{formData}</pre> */}
      <Box marginBottom={4}>
        <BillingInfo
          onChange={(isValid, data) => {
            setIsBillingInfoFormValid(isValid);
            updateFormData(data);
          }}
        />
      </Box>
      <Box marginBottom={4}>
        <PaymentMethod
          onChange={(isValid, data) => {
            setIsPaymentMethodFormValid(isValid);
            updateFormData(data);
          }}
        />
      </Box>
      <Box marginBottom={4}>
        <Divider />
      </Box>
      <Box marginBottom={6}>
        <FsPendingButton
          onClick={handleSubscribe}
          variant="contained"
          color="primary"
          pending={pending}
          width={160}
          disabled={!(isBillingInfoFormValid && isPaymentMethodFormValid)}
        >
          Subscribe
        </FsPendingButton>
        <FsButton
          color="inherit"
          onClick={() => cancelRedirect()}
          style={{ marginLeft: 10 }}
        >
          Cancel
        </FsButton>
      </Box>
    </Box>
  );
};

export default PayAsYouGrow;
